import * as React from "react";
import { useEffect, useMemo } from "react";
import loadAsync from "routing/loadAsync";
import ServerUnavailablePage from "pages/ServerUnavailablePage";
import { useStore } from "stores/connect";
import "bootstrap/less/bootstrap.less";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
import { ServerAvailabilityStore } from "stores/sessions/ServerAvailabilityStore";
import { SessionStore } from "stores/sessions/SessionStore";
import GraylogThemeProvider from "theme/GraylogThemeProvider";
import GlobalThemeStyles from "theme/GlobalThemeStyles";
import Notifications from "routing/Notifications";
const LoginPage = loadAsync(() => import(
  /* webpackChunkName: "LoginPage" */
  "pages/LoginPage"
));
const LoadingPage = loadAsync(() => import(
  /* webpackChunkName: "LoadingPage" */
  "pages/LoadingPage"
));
const LoggedInPage = loadAsync(() => import(
  /* webpackChunkName: "LoggedInPage" */
  "pages/LoggedInPage"
));
const SERVER_PING_TIMEOUT = 2e4;
const LoggedOutThemeProvider = ({ children }) => /* @__PURE__ */ React.createElement(GraylogThemeProvider, { userIsLoggedIn: false }, /* @__PURE__ */ React.createElement(GlobalThemeStyles, null), /* @__PURE__ */ React.createElement(Notifications, null), children);
const AppFacade = () => {
  const currentUser = useStore(CurrentUserStore, (state) => state == null ? void 0 : state.currentUser);
  const server = useStore(ServerAvailabilityStore, (state) => state == null ? void 0 : state.server);
  const username = useStore(SessionStore, (state) => {
    var _a;
    return (_a = state == null ? void 0 : state.username) != null ? _a : "";
  });
  useEffect(() => {
    const interval = setInterval(ServerAvailabilityStore.ping, SERVER_PING_TIMEOUT);
    return () => clearInterval(interval);
  }, []);
  const ThemeProvider = useMemo(
    () => server.up && username && currentUser ? React.Fragment : LoggedOutThemeProvider,
    [currentUser, server.up, username]
  );
  const content = useMemo(() => {
    if (server.up === false) {
      return /* @__PURE__ */ React.createElement(ServerUnavailablePage, { server });
    }
    if (!username) {
      return /* @__PURE__ */ React.createElement(LoginPage, null);
    }
    if (!currentUser) {
      return /* @__PURE__ */ React.createElement(LoadingPage, { text: "We are preparing the web interface for you..." });
    }
    return /* @__PURE__ */ React.createElement(LoggedInPage, null);
  }, [currentUser, server, username]);
  return /* @__PURE__ */ React.createElement(ThemeProvider, null, content);
};
export default AppFacade;
